import { Modal } from '../../../components/ui/Modal'
import { resultDisplayName } from '../format'
import type { CatalogResultCard } from '../types'
import { ConfiguratorCore } from './ConfiguratorCore'

export interface ConfiguratorDrawerProps {
  readonly open: boolean
  readonly onClose: () => void
  readonly card: CatalogResultCard
}

/**
 * Surface B (UID-34 / ADR-0097 §8.1/8.2) — the PDP configurator opened from
 * a configurable result card's "Configure" CTA (`ResultCard.tsx`). Uses the
 * shared `Modal` shell rather than a bespoke slide-from-right treatment,
 * mirroring `PartPreviewDrawer.tsx`'s precedent for a design comp labeled
 * "drawer" (`Modal`'s own doc comment: it backs both shapes,
 * open-questions.md #10) — the 760px width from the design's spec is the
 * only surface-specific choice; the focus-trap/Escape/backdrop/return-focus
 * behavior comes for free.
 *
 * Renders the SAME `ConfiguratorCore` as Surface A — only the chrome
 * differs (ADR-0097 Decision 1). `card.configSchema` is required by this
 * component's only caller (`ResultCard`'s "Configure" CTA is gated on its
 * presence) — a card with no `configSchema` never reaches this drawer.
 */
export function ConfiguratorDrawer({ open, onClose, card }: ConfiguratorDrawerProps) {
  const { sourceable, configSchema } = card
  if (!configSchema) return null

  return (
    <Modal open={open} onClose={onClose} title={resultDisplayName(sourceable)} maxWidth={760}>
      <ConfiguratorCore
        familyName={resultDisplayName(sourceable)}
        schema={configSchema}
        imageRef={sourceable.imageRef ?? null}
        onAdded={onClose}
      />
    </Modal>
  )
}
